export default "__VITE_ASSET__CXhnLreR__"